import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles/QuestionFormModal.module.css";
import { Button, Form, Nav, Tab, Modal } from "react-bootstrap";
import { AnswerTextQuiz } from "./AnswerTextQuiz";
import { ListOptionQuiz } from "./ListOptionQuiz";
import clsx from "clsx";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { uploadImageAction } from "@redux/modules/upload/slices";
import { SpinnerMark } from "@components/SpinnerMark";
import * as Yup from "yup";
import { InputField } from "@components/Input";
import { replaceErrorImage } from "@helpers";

const QuestionFormModal = ({ onSubmit, children, initialValues }) => {
  const dispatch = useDispatch();
  // state
  const [showAddQuestions, setShowAddQuestions] = useState(false);

  // variables
  // logics before hooks

  const handleShow = () => {
    setShowAddQuestions(true);
  };
  const handleClose = () => {
    setShowAddQuestions(false);
    formik.resetForm({
      initialValues: {
        title: "",
        score: "",
        image: "",
        imageFile: null,
        options: [],
        textAnswer: "",
        type: 0,
      },
    });
  };

  const validationSchema = Yup.object().shape({
    type: Yup.number(),
    options: Yup.array()
      // .compact((val) => val.isDeleted == true)
      .when("type", {
        is: (val) => {
          return val == 0 || val == 1;
        },
        then: Yup.array()
          .min(2, "You must have at least 2 options")
          .of(
            Yup.object().shape({
              title: Yup.string().when("isDeleted ", {
                is: (val) => val != true,
                then: Yup.string().required("Require"),
              }),
              isCorrectAnswer: Yup.boolean(),
              isDeleted: Yup.boolean(),
            })
          ),
      }),

    textAnswer: Yup.string().when("type", {
      is: (val) => {
        return val == 2 || val == 3;
      },
      then: Yup.string().required("You must fill correct answer"),
    }),
    title: Yup.string()
      .required("Question title is required")
      .max(100, "Question title require maximum of 100 characters"),
    score: Yup.number().required("Score is required"),
  });
  // hooks
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: (values) => {
      const isChosenCorrectAnswer = !formik.values.options.every((option) => {
        return option.isCorrectAnswer != true;
      });
      if (
        !isChosenCorrectAnswer &&
        (formik.values.type == 1 || formik.values.type == 0)
      ) {
        formik.setFieldError(
          "options",
          "You must chose at least 1 correct answer"
        );
      } else {
        formik.setFieldError("options", null);
        onSubmit(values);
        handleClose();
      }
    },
  });
  // logics
  const changeTextAnswer = (event) => {
    formik.setFieldValue("textAnswer", event.target.value);
  };

  const handleAddOption = (option) => {
    const newOptions = [...formik.values.options, option];
    formik.setFieldValue("options", newOptions);
  };

  const handleDeleteOption = (id) => {
    const options = [...formik.values.options];
    const optionIndex = options.findIndex((option) => option.id == id);
    // options[optionIndex].isDeleted = true;
    // options[optionIndex].title = "";
    options.splice(optionIndex, 1, {
      ...options[optionIndex],
      isDeleted: true,
    });
    formik.setFieldValue("options", options);
  };

  const handleSelectType = (key) => {
    formik.setFieldValue("type", parseInt(key));
  };

  const handleUploadImage = (event) => {
    const file = event.target.files[0];
    formik.setFieldValue("imageFile", file);
    dispatch(uploadImageAction(file));
  };
  // UI partials
  // effects
  const uploadedImage = useSelector((state) => state.upload.uploadImage);
  useEffect(() => {
    formik.setFieldValue("image", uploadedImage?.url || "");
  }, [uploadedImage]);

  useEffect(() => {
    formik.setValues(initialValues);
    console.log(formik.values);
  }, [initialValues]);

  // render
  return (
    <div className="">
      <span onClick={handleShow}>{children}</span>

      <Modal show={showAddQuestions} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>Question Type</h6>
          <div
            className={clsx(
              styles.tabChildContainer,
              "d-flex justify-content-center flex-column gap-2 my-4"
            )}
          >
            <Tab.Container
              defaultActiveKey={formik.values.type}
              onSelect={handleSelectType}
              activeKey={formik.values.type}
            >
              <Nav
                variant="pills"
                className="justify-content-center gap-3 mb-4"
              >
                <Nav.Item>
                  <Nav.Link eventKey={0}>Single Choice</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey={1}>Multiple Choice</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey={2}>Single Line Text</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey={3}>Multiple Line Text</Nav.Link>
                </Nav.Item>
              </Nav>

              <div className="d-flex justify-content-between gap-3">
                <Form.Group className="mb-3 position-relative flex-shrink-1">
                  <Form.Label>Image</Form.Label>
                  <div
                    variant="outline-primary"
                    className="shadow-sm position-relative d-block"
                  >
                    <img
                      src={
                        formik.values.imageFile
                          ? URL.createObjectURL(formik.values.imageFile)
                          : formik.values.image
                          ? formik.values.image
                          : "https://gambolthemes.net/html-items/cursus_main_demo/images/placeholder-image.png"
                      }
                      alt=""
                      width={"50px"}
                      onError={replaceErrorImage}
                    />
                    {uploadedImage.processing && <SpinnerMark size={"sm"} />}
                    <Form.Group controlId="formFileMultiple">
                      <Form.Control
                        type="file"
                        multiple
                        name="imageFile"
                        onChange={handleUploadImage}
                      />
                    </Form.Group>
                  </div>
                </Form.Group>
                <div className="d-flex flex-column flex-grow-1">
                  <InputField
                    name={"title"}
                    type={"text"}
                    label={"Question Title*"}
                    placeholder="Question title here"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    autoComplete="off"
                    touchedValue={formik.touched.title}
                    errorsValue={formik.errors.title}
                  />
                </div>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Score</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Score"
                    name="score"
                    value={formik.values.score}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.score && formik.errors.score}
                  />
                  <Form.Control.Feedback type="invalid" className="text-left">
                    {formik.touched.score && formik.errors.score}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              <Tab.Content>
                <Tab.Pane eventKey={0}>
                  <ListOptionQuiz
                    choiceType={"radio"}
                    onAdd={handleAddOption}
                    onDelete={handleDeleteOption}
                    values={formik.values}
                    onChange={formik.handleChange}
                    formik={formik}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey={1}>
                  <ListOptionQuiz
                    choiceType={"checkbox"}
                    onAdd={handleAddOption}
                    onDelete={handleDeleteOption}
                    values={formik.values}
                    onChange={formik.handleChange}
                    formik={formik}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey={2}>
                  <AnswerTextQuiz
                    onChange={changeTextAnswer}
                    value={formik.values.textAnswer}
                    formik={formik}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey={3}>
                  <AnswerTextQuiz
                    as={"textarea"}
                    rows={5}
                    onChange={changeTextAnswer}
                    value={formik.values.textAnswer}
                    formik={formik}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button className="btn btn-primary" onClick={formik.handleSubmit}>
            Save Question
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

/* required: display name */
QuestionFormModal.displayName = "QuestionFormModal";

/* required: props types */
QuestionFormModal.propTypes = {};

/* required: default props */
QuestionFormModal.defaultProps = {
  initialValues: {
    title: "",
    score: "",
    image: "",
    imageFile: null,
    options: [],
    textAnswer: "",
    type: 0,
  },
};

export { QuestionFormModal };
